// SnackProfile.jsx
import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab, Accordion } from "react-bootstrap";
import SnackNavBarProfile from "./profile-navbar/SnackProfileNavBar";
import SnackProfileInfoUser from "./profile-user-info/SnackProfileInfoUser";
import SnackMenuTabularDays from "./profile-menu-days/SnackMenuTabularDays";
import SnackProfileUserWorkouts from "./profile-user-workouts/SnackProfileUserWorkouts";
import ProfileUserDetailWorkout from "./profile-user-workouts/profile-user-detail-workout/ProfileUserDetailWorkout";
import { useStatusBoard } from "../../utensils/StatusBoardContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SnackProfile.css";
import SnackProfileActivity from "./profile-user-workouts/profile-user-activity/SnackProfileActivity";
import SnackUserEvaluation from "./profile-user-info/profile-user-evaluation/SnackUserEvaluation";
import SnackProfileUserNutrition from "./profile-user-nutrition/SnackProfileUserNutrition";
import SnackMenuTabularDaysNutrition from "./profile-menu-days-nutrition/SnackMenuTabularDaysNutrition";
import SnackProfileNutritionImage from "./profile-user-nutrition/profile-user-nutrition-image/SnackProfileUserNutritionImage";
import SnackUserReservations from "../reservation/SnackUserReservations";
import { useUser } from "../../utensils/UserContext";
import SnackMyClass from "../reservation/SnackMyClass";
import SnackCalculator from "../calculator/SnackCalculator";
import SnackMyTemplate from "../reservation/SnackMyTemplate";
import { useAdminTemplates } from "../../market/warehouse-baserow/useAdminTemplates";
import SnackCrudUsers from "../users/SnackCrudUsers";
import SnackNewEvaluations from "../evaluations/SnackNewEvaluations";
import { Modal, Button } from "react-bootstrap";
import SnackEditEvaluations from "../evaluations/SnackEditEvaluation";
import SnackNewTemplate from "../reservation/SnackNewTemplate";
import SnackTemplates from "../templates/SnackTemplates";
import SnackEditNutritionalEvaluations from "../evaluations/SnackEditNutritionalEvaluations";
import SnackNewNutritionalEvaluations from "../evaluations/SnackNewNutritionalEvaluations";
import SnackNewExercise from "../exercises/SnackNewExercise";
import SnackEditExercise from "../exercises/SnackEditExercise";
import SnackNewRoutine from "../routines/SnackNewRoutine";
import SnackNewRoutineNutrition from "../routines/SnackNewRoutineNutrition";
import SnackReportReservations from "../../snacks/reservation/SnackReportReservations";

const SnackProfile = () => {
  const [activeKey, setActiveKey] = useState("0");
  const [nutritionKey, setNutritionKey] = useState("0"); // Índice activo para el segundo acordeón
  const [exerciseTitle, setExerciseTitle] = useState("Mi ejercicio actual");
  const { selectedExercise } = useStatusBoard();
  const headerRef = useRef(null);
  const [refreshReservations, setRefreshReservations] = useState(true);

  const [tabKey, setTabKey] = useState("fitness");
  const [calcKey, setCalcKey] = useState(0); // Forzar recarga del iframe

  const [refreshMyClassesKey, setRefreshMyClassesKey] = useState(Date.now());

  // Modal Evaluacion
  const [showEvaluationModal, setShowEvaluationModal] = useState(false);
  const handleOpenEvaluationModal = () => setShowEvaluationModal(true);
  const handleCloseEvaluationModal = () => setShowEvaluationModal(false);

  // Modal eevaluación nutricional.
  // Modal Evaluación nutricional (definirlo)
  const [showEvaluationNutritionModal, setShowEvaluationNutritionModal] =
    useState(false);
  const handleOpenEvaluationNutritionModal = () =>
    setShowEvaluationNutritionModal(true);
  const handleCloseEvaluationNutritionModal = () =>
    setShowEvaluationNutritionModal(false);

  // Rol del usuario.
  const { user } = useUser();
  const isAdmin = user?.Rol === "1-administrador";
  const isAgent = user?.Rol === "3-agencia";

  // Modal gestión ejercicios.
  const [showExerciseModal, setShowExerciseModal] = useState(false);
  const handleOpenExerciseModal = () => setShowExerciseModal(true);
  const handleCloseExerciseModal = () => setShowExerciseModal(false);

  // Modal gestión rutinas.
  const [showRoutineModal, setShowRoutineModal] = useState(false);
  const handleOpenRoutineModal = () => setShowRoutineModal(true);
  const handleCloseRoutineModal = () => setShowRoutineModal(false);

  useEffect(() => {
    if (selectedExercise) {
      setExerciseTitle(
        `Mi ejercicio actual: ${selectedExercise.NombreEjercicio}`
      );
      setActiveKey("2"); // Cambiar al acordeón de detalles
    }
  }, [selectedExercise]);

  // Función para abrir la pestaña de "Mi rutina de entrenamiento"
  const openAccordion = () => {
    setActiveKey("1");
  };

  return (
    <div className="profile-container vh-100">
      <SnackNavBarProfile />

      {/* Panel Tabular */}
      <Tabs
        activeKey={tabKey}
        onSelect={(key) => {
          setTabKey(key);
          if (key === "valoracion") {
            setCalcKey((prev) => prev + 1); // Forzar recarga del iframe
          }
        }}
        id="profile-tabs"
        className="tab-container m-3"
      >
        {/* Tab Fitness */}
        <Tab eventKey="fitness" title="Fitness" className="tab-button">
          {/* Primer acordeón: Información y entrenamiento */}
          <Accordion
            activeKey={activeKey}
            onSelect={setActiveKey}
            className="m-3"
          >
            <Accordion.Item eventKey="0">
              <Accordion.Header>Mi perfil fitness</Accordion.Header>
              <Accordion.Body>
                <SnackProfileInfoUser />
                <SnackUserEvaluation />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>Mi rutina de entrenamiento</Accordion.Header>
              <Accordion.Body>
                <SnackMenuTabularDays />
                <SnackProfileUserWorkouts />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" ref={headerRef}>
              <Accordion.Header>{exerciseTitle}</Accordion.Header>
              <Accordion.Body>
                <ProfileUserDetailWorkout openAccordion={openAccordion} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>Mi actividad fitness</Accordion.Header>
              <Accordion.Body>
                <SnackProfileActivity />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Tab Nutrición */}
        <Tab eventKey="nutrition" title="Nutrición" className="tab-button">
          {/* Segundo acordeón: Plan de nutrición */}
          <Accordion
            activeKey={nutritionKey}
            onSelect={setNutritionKey}
            className="m-3"
          >
            <Accordion.Item eventKey="0">
              <Accordion.Header>Mi plan de nutrición</Accordion.Header>
              <Accordion.Body>
                <SnackMenuTabularDaysNutrition />
                <SnackProfileUserNutrition />
                {/* Aquí podrías insertar un componente específico, por ejemplo: <NutritionPlan /> */}
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>Lista de alimentos sustitutos</Accordion.Header>
              <Accordion.Body>
                <SnackProfileNutritionImage />
                {/* Aquí podrías insertar un componente específico, por ejemplo: <NutritionPlan /> */}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Tab exclusivo según el rol */}
        {isAdmin ? (
          // 🟢 Solo administradores
          <Tab eventKey="classes" title="Mis clases" className="tab-button">
            <Accordion className="m-3">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Mis clases</Accordion.Header>
                <Accordion.Body>
                  <SnackMyClass
                    shouldRefresh={refreshReservations}
                    refreshKey={refreshMyClassesKey}
                  />
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>Mis plantillas</Accordion.Header>
                <Accordion.Body>
                  <SnackMyTemplate
                    shouldRefresh={refreshReservations}
                    onClassCreated={() => setRefreshMyClassesKey(Date.now())}
                  />
                </Accordion.Body>
              </Accordion.Item>

              {/* Reportes */}
              <Accordion.Item eventKey="2">
                <Accordion.Header>Reportes</Accordion.Header>
                <Accordion.Body>
                  <SnackReportReservations />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Tab>
        ) : !isAgent ? (
          // 🔵 Solo usuarios comunes (no admin, no agente)
          <Tab
            eventKey="reservations"
            title="Mis reservas"
            className="tab-button"
          >
            <Accordion
              className="m-3"
              activeKey={activeKey}
              onSelect={(key) => {
                setActiveKey(key);
                setRefreshReservations(key === "0");
              }}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>Mis reservas</Accordion.Header>
                <Accordion.Body>
                  <SnackUserReservations
                    shouldRefresh={refreshReservations}
                    forceOpenTab={() => setActiveKey("0")}
                  />
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>Clases disponibles</Accordion.Header>
                <Accordion.Body>
                  <SnackMyClass shouldRefresh={activeKey === "1"} />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Tab>
        ) : null}

        <Tab
          eventKey="valoracion"
          title="Mi valoración integral"
          className="tab-button"
        >
          <div className="m-3">
            <SnackCalculator key={calcKey} />
          </div>
        </Tab>
        {isAdmin && (
          <Tab
            eventKey="userManagement"
            title="Gestionar usuarios"
            className="tab-button"
          >
            <div className="m-3">
              <SnackCrudUsers />
            </div>
          </Tab>
        )}

        {isAdmin && (
          <Tab
            eventKey="templatesManagement"
            title="Gestionar plantillas"
            className="tab-button"
          >
            <div className="m-3">
              <SnackTemplates />
            </div>
          </Tab>
        )}

        {(isAdmin || isAgent) && (
          <Tab
            eventKey="evaluationsManagement"
            title="Gestionar evaluaciones"
            className="tab-button"
            onEnter={handleOpenEvaluationModal}
          >
            <div className="m-3">
              {/* Puedes dejar esto vacío porque el contenido se mostrará en el modal */}
            </div>
          </Tab>
        )}

        {tabKey === "evaluationsManagement-create" && (
          <Tab
            eventKey="evaluationsManagement-create"
            title="📝 Crear valoración"
          >
            <div className="m-3">
              <SnackNewEvaluations />
            </div>
          </Tab>
        )}

        {tabKey === "evaluationsManagement-edit" && (
          <Tab
            eventKey="evaluationsManagement-edit"
            title="✏️ Editar valoración"
          >
            <div className="m-3">
              {/* Componente para editar formulario */}
              <SnackEditEvaluations />
            </div>
          </Tab>
        )}

        {(isAdmin || isAgent) && (
          <Tab
            eventKey="evaluationsNutritionManagement"
            title="Gestionar evaluación nutricional"
            className="tab-button"
            onEnter={handleOpenEvaluationNutritionModal} // ⬅️ SEPARADO
          >
            <div className="m-3"></div>
          </Tab>
        )}

        {tabKey === "evaluationsNutritionManagement-create" && (
          <Tab
            eventKey="evaluationsNutritionManagement-create"
            title="📝 Crear evaluación nutricional"
          >
            <div className="m-3">
              <SnackNewNutritionalEvaluations />
            </div>
          </Tab>
        )}

        {tabKey === "evaluationsNutritionManagement-edit" && (
          <Tab
            eventKey="evaluationsNutritionManagement-edit"
            title="✏️ Editar evaluación nutricional"
          >
            <div className="m-3">
              <SnackEditNutritionalEvaluations />
            </div>
          </Tab>
        )}

        {isAdmin && (
          <Tab
            eventKey="exerciseManagement"
            title="Gestionar ejercicios"
            className="tab-button"
            onEnter={handleOpenExerciseModal}
          >
            <div className="m-3">{/* Controlado por modal */}</div>
          </Tab>
        )}

        {tabKey === "exerciseManagement-create" && (
          <Tab eventKey="exerciseManagement-create" title="➕ Nuevo ejercicio">
            <div className="m-3">
              <SnackNewExercise />
            </div>
          </Tab>
        )}

        {tabKey === "exerciseManagement-edit" && (
          <Tab eventKey="exerciseManagement-edit" title="✏️ Editar ejercicio">
            <div className="m-3">
              <SnackEditExercise />
            </div>
          </Tab>
        )}

        {(isAdmin || isAgent) && (
          <Tab
            eventKey="routineManagement"
            title="Gestionar rutinas"
            className="tab-button"
            onEnter={handleOpenRoutineModal}
          >
            <div className="m-3">{/* Controlado por modal */}</div>
          </Tab>
        )}

        {tabKey === "routineManagement-fitness" && (
          <Tab
            eventKey="routineManagement-fitness"
            title="🏋️ Nueva rutina de entrenamiento"
          >
            <div className="m-3">
              <SnackNewRoutine />
            </div>
          </Tab>
        )}

        {tabKey === "routineManagement-nutrition" && (
          <Tab
            eventKey="routineManagement-nutrition"
            title="🥗 Nueva rutina de nutrición"
          >
            <div className="m-3">
              <SnackNewRoutineNutrition />
            </div>
          </Tab>
        )}
      </Tabs>

      {/* Modal Evaluación */}
      <Modal
        show={showEvaluationModal}
        onHide={handleCloseEvaluationModal}
        centered
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#f64012", // color principal directo
            color: "#ffffff",
          }}
        >
          <Modal.Title>Gestionar evaluaciones</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <p style={{ marginBottom: "1rem" }}>Selecciona una acción:</p>

          <Button
            style={{
              backgroundColor: "#f64012",
              borderColor: "#f64012",
              color: "#fff",
            }}
            className="m-2"
            onClick={() => {
              setTabKey("evaluationsManagement-create");
              setShowEvaluationModal(false);
            }}
          >
            Crear nuevo formulario de valoración
          </Button>

          <Button
            style={{
              backgroundColor: "#6c757d", // gris Bootstrap
              borderColor: "#6c757d",
              color: "#fff",
            }}
            className="m-2"
            onClick={() => {
              setTabKey("evaluationsManagement-edit");
              setShowEvaluationModal(false);
            }}
          >
            Editar formulario de valoración
          </Button>
        </Modal.Body>
      </Modal>

      {/* Modal Evaluación nutricional */}
      <Modal
        show={showEvaluationNutritionModal}
        onHide={handleCloseEvaluationNutritionModal}
        centered
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#f64012",
            color: "#ffffff",
          }}
        >
          <Modal.Title>Gestionar evaluaciones nutricionales</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <p style={{ marginBottom: "1rem" }}>Selecciona una acción:</p>

          <Button
            style={{
              backgroundColor: "#f64012",
              borderColor: "#f64012",
              color: "#fff",
            }}
            className="m-2"
            onClick={() => {
              setTabKey("evaluationsNutritionManagement-create");
              setShowEvaluationNutritionModal(false);
            }}
          >
            Crear evaluación nutricional
          </Button>

          <Button
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
            }}
            className="m-2"
            onClick={() => {
              setTabKey("evaluationsNutritionManagement-edit");
              setShowEvaluationNutritionModal(false);
            }}
          >
            Editar evaluación nutricional
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        show={showExerciseModal}
        onHide={handleCloseExerciseModal}
        centered
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#f64012",
            color: "#ffffff",
          }}
        >
          <Modal.Title>Gestionar ejercicios</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <p style={{ marginBottom: "1rem" }}>Selecciona una acción:</p>

          <Button
            style={{
              backgroundColor: "#f64012",
              borderColor: "#f64012",
              color: "#fff",
            }}
            className="m-2"
            onClick={() => {
              setTabKey("exerciseManagement-create");
              setShowExerciseModal(false);
            }}
          >
            Nuevo ejercicio
          </Button>

          <Button
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
            }}
            className="m-2"
            onClick={() => {
              setTabKey("exerciseManagement-edit");
              setShowExerciseModal(false);
            }}
          >
            Editar ejercicio
          </Button>
        </Modal.Body>
      </Modal>

      {/* Modal para rutinas */}
      <Modal show={showRoutineModal} onHide={handleCloseRoutineModal} centered>
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#f64012",
            color: "#ffffff",
          }}
        >
          <Modal.Title>Gestionar rutinas</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <p style={{ marginBottom: "1rem" }}>Selecciona una acción:</p>

          <Button
            style={{
              backgroundColor: "#f64012",
              borderColor: "#f64012",
              color: "#fff",
            }}
            className="m-2"
            onClick={() => {
              setTabKey("routineManagement-fitness");
              setShowRoutineModal(false);
            }}
          >
            Nueva rutina de entrenamiento
          </Button>

          <Button
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
            }}
            className="m-2"
            onClick={() => {
              setTabKey("routineManagement-nutrition");
              setShowRoutineModal(false);
            }}
          >
            Nueva rutina de nutrición
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SnackProfile;
